import React from 'react';
import { ErrorIcon } from '../icons/icons';
import { Icon } from '../icon';
import Colors from '../colors';
import styles from './error-page.css';

interface ErrorPageProps {
  title?: string;
  description?: string;
}

export const ErrorPage = (props: ErrorPageProps) => {
  const { title, description } = props;
  return (
    <div className={styles.wrapper} data-testid="ErrorPage.wrapper">
      <Icon color={Colors.Error} size={'64px'} className={styles.icon}>
        <ErrorIcon />
      </Icon>
      {title ? <div className={styles.title}>{title}</div> : null}
      {description ? <div className={styles.description}>{description}</div> : null}
    </div>
  );
};

ErrorPage.defaultProps = {
  title: 'Well, this is a bit embarrassing! This page didn’t load.',
  description:
    'Sorry about that. We’re not sure what caused the error but you can try loading this page again with a browser refresh. If the problem continues, please contact us.'
};
